<ion-header>
    <ion-toolbar>
        <ion-title>
            Stock Count
        </ion-title>
        <ion-buttons slot="start">
            <ion-button (click)="closeModal()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button color="success" fill="clear" slot="end" shape="round"
                        (click)="uploadStockCounts()">
                <ion-icon name="sync"slot="icon-only"></ion-icon>
            </ion-button>
        </ion-buttons>
<!--        <ion-searchbar animated debounce="300" [(ngModel)]="queryText">-->
<!--        </ion-searchbar>-->
    </ion-toolbar>

</ion-header>

<ion-content>
    <ion-button expand="full" (click)="showNewCountOption = !showNewCountOption" color="light" shape="round">
        Create New Stock Count
    </ion-button>
    <ion-item *ngIf="showNewCountOption">
        <ion-label>Enter Zone</ion-label>
        <ion-input type="text" placeholder="Zone" slot="end" [(ngModel)]="zoneNewCount"></ion-input>
        <ion-button slot="end" (click)="checkZoneForCounting()">
            <ion-icon slot="icon-only" name="add" color="light"></ion-icon>
        </ion-button>
    </ion-item>
    <ion-list>
        <ion-item *ngFor="let stockCount of stockCountList | filterDocs: queryText"
                  (click)="stockTakeModal(stockCount)">
            <ion-label>
                <h4><strong> {{ 'Zone: ' + stockCount.comment }} </strong></h4>
                <p>{{ stockCount.creationDate | date: 'dd/MM/yyyy HH:mm'}}</p>
            </ion-label>
        </ion-item>
    </ion-list>
</ion-content>
